export default {"src":"/_next/static/media/TrashRed.2ba41ea9.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};